export const BrowserCapa_Selenium = "selenium.webdriverSupport";